import termsV20260611 from './versions/terms-2026-06-11';
import termsV20260717 from './versions/terms-2026-07-17';
import termsV20260828 from './versions/terms-2026-08-28';
import termsV20260828Ko from './versions/terms-2026-08-28-ko';
import privacyV20260611 from './versions/privacy-2026-06-11';
import privacyV20260717 from './versions/privacy-2026-07-17';
import privacyV20260828 from './versions/privacy-2026-08-28';
import privacyV20260828Ko from './versions/privacy-2026-08-28-ko';
import businessTermsV20260814 from './versions/business-terms-2026-08-14';
import businessTermsV20260828 from './versions/business-terms-2026-08-28';
import businessPrivacyV20260814 from './versions/business-privacy-2026-08-14';
import businessPrivacyV20260828 from './versions/business-privacy-2026-08-28';
import refundV20260611 from './versions/refund-2026-06-11';
import refundV20260717 from './versions/refund-2026-07-17';

/**
 * 정책 문서와 그 버전 목록.
 *
 * ## 새 버전을 올리는 방법
 * 1. `versions/<policy>-<YYYY-MM-DD>.js` 를 만든다 (기존 파일을 복사해 내용만 수정)
 * 2. 아래 `versions` 배열 **맨 뒤**에 import한 모듈을 추가한다
 * 3. 끝. 라우팅·시행일 선택·푸터 링크는 자동으로 최신 버전을 따라간다
 *
 * 같은 시행일의 다른 언어본은 `lang` 을 지정한 파일(예: `terms-2026-08-28-ko.js`)로 만들어 함께 넣는다.
 * 어드민 마이페이지 Policies 탭에서 등록한 버전은 DB 에 저장되고 usePolicyVersions 가 이 목록과 합친다.
 *
 * 배열은 **시행일 오름차순**(과거 → 최신)으로 둔다.
 * 정책 원문은 노션 Policy Hub에서 관리하고, 확정된 버전만 여기로 옮긴다.
 */
export const POLICIES = {
  terms: {
    path: '/terms',
    versions: [termsV20260611, termsV20260717, termsV20260828, termsV20260828Ko],
  },
  privacy: {
    path: '/privacy',
    versions: [privacyV20260611, privacyV20260717, privacyV20260828, privacyV20260828Ko],
  },
  'business-terms': {
    path: '/business/terms',
    locale: 'ko',
    versions: [businessTermsV20260814, businessTermsV20260828],
  },
  'business-privacy': {
    path: '/business/privacy',
    locale: 'ko',
    versions: [businessPrivacyV20260814, businessPrivacyV20260828],
  },
  refund: {
    path: '/refund-policy',
    versions: [refundV20260611, refundV20260717],
  },
};

/** `/terms/2026-06-11` 형태의 경로 */
export const versionPath = (policyKey, effectiveDate) =>
  `${POLICIES[policyKey].path}/${effectiveDate}`;

const EN_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const policyLocale = (policyKey) => POLICIES[policyKey]?.locale ?? 'en';

export const formatPolicyDate = (iso, locale) => {
  const [y, m, d] = iso.split('-').map(Number);
  return locale === 'ko' ? `${y}년 ${m}월 ${d}일` : `${EN_MONTHS[m - 1]} ${d}, ${y}`;
};

export const policyDateLabel = (locale, upcoming) => {
  if (locale === 'ko') return upcoming ? '시행 예정일' : '시행일';
  return upcoming ? 'Takes effect' : 'Last updated';
};
